<template>
  <v-card flat class="pa-4">
    <v-switch v-model="preferences.distillDuration" label="Track duration" dense/>
    <v-switch v-model="preferences.distillIncomplete" label="Allow incomplete distillations" dense/>
    <v-switch v-model="preferences.distillLot" label="Allow lots of output spirits to be specified" dense/>
    <v-row dense class="mt-4">
      <v-col cols="3 pt-3">Numbering</v-col>
      <v-col cols="3">
        <v-text-field label="Prefix" v-model="preferences.numberPrefix" :rules="[fieldRules.maxLength(10)]" outlined dense :counter="10"/>
      </v-col>
      <v-col cols="3">
        <v-text-field label="Suffix" v-model="preferences.numberSuffix" :rules="[fieldRules.maxLength(10)]" outlined dense :counter="10"/>
      </v-col>
      <v-col cols="3">
        <decimal-number-input label="Start at" v-model="preferences.numberStart" :precision="0" integer prefix=""/>
      </v-col>
    </v-row>
  </v-card>
</template>

<script>
export default {
  name: 'ProductionDistillingPreferences',
  data() {
    return {
      preferences: {}
    }
  },
  watch: {
    preferences: {
      async handler() {
        const results = await this.$apiCall(`mutation ProductionDistillingPreferences($input:DistillingPreferencesInput!) {
                                              distillingSetPreferences(input:$input) {
                                                distillDuration, distillIncomplete, distillLot
                                                numberPrefix, numberSuffix, numberStart
                                              }
                                            }`,
                                            {input:this.preferences});
        if (!results.error)
          this.$emit('update', results.data.distillingSetPreferences)
      },
      immediate: false,
      deep: true
    }
  },
  async created() {
    const results = await this.$apiCall(`query ProductionDistillingPreferences {
                                          distillingPreferences {
                                            distillDuration, distillIncomplete, distillLot
                                            numberPrefix, numberSuffix, numberStart
                                          }
                                        }`,
                                        {});
    if (!results.error)
      this.preferences = results.data.distillingPreferences;
  }
}
</script>